<template>
  <el-config-provider :locale="locale">
    <div id="main_qiankun_app">
      <router-view />
    </div>
  </el-config-provider>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  h,
  toRefs,
  computed,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import * as echarts from "echarts";

import zhCn from "element-plus/dist/locale/zh-cn.mjs";
export default defineComponent({
  components: {},
  setup() {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    let ws;
    const language = ref("zh-cn");
    const locale = computed(() => (language.value === "zh-cn" ? zhCn : en));
    const state = reactive({});

    //监听子应用发起的路由跳转消息并处理
    function handleWindowMessage(e) {
      console.log("主应用接收到子应用发过来的数据====>", e);
      if (e.data?.type === 'navigate') {
        const systemId = e.data.query.systemId;
        if(systemId){
          store.commit("permission/SET_SUB_SYSTEM_ID", systemId);
          sessionStorage.setItem("subSystemId", systemId);
        }
        router.push({ path: e.data.path, query: e.data.query });
      }
    }
    provide("echarts", echarts);

    onMounted(() => {
      window.addEventListener("message", handleWindowMessage);
    });
    return {
      ...toRefs(state),
      locale,
    };
  },
});
</script>
<style lang="less">
@import url("./styles/index.less");
#main_qiankun_app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  > div {
    height: 100%;
    width: 100%;
  }
  // background-color: @background_2;
}
</style>
